/**
 * Veridex Protocol SDK - Sui Chain Module
 */

export { SuiClient } from './SuiClient.js';
export type { SuiClientConfig } from './SuiClient.js';
